<template>
  <div class="page-card">
    <div class="page-card__head">
      <div>
        <div class="page-card__title">投喂记录</div>
        <div class="page-card__desc">排查投喂数据，后续适合接列表筛选、时间轴和异常标记。</div>
      </div>
      <button class="action-button">导出记录</button>
    </div>

    <div class="placeholder-grid">
      <div class="placeholder-card">记录列表</div>
      <div class="placeholder-card">用户 / 宠物筛选</div>
      <div class="placeholder-card">记录趋势</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeedingRecordView"
}
</script>
